var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarFallback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20C18.9 20 17.9583 19.6083 17.175 18.825C16.3917 18.0417 16 17.1 16 16C16 14.9 16.3917 13.9583 17.175 13.175C17.9583 12.3917 18.9 12 20 12C21.1 12 22.0417 12.3917 22.825 13.175C23.6083 13.9583 24 14.9 24 16C24 17.1 23.6083 18.0417 22.825 18.825C22.0417 19.6083 21.1 20 20 20ZM14 28C13.45 28 12.9793 27.8043 12.588 27.413C12.196 27.021 12 26.55 12 26V25.2C12 24.6333 12.146 24.1123 12.438 23.637C12.7293 23.1623 13.1167 22.8 13.6 22.55C14.6333 22.0333 15.6833 21.6457 16.75 21.387C17.8167 21.129 18.9 21 20 21C21.1 21 22.1833 21.129 23.25 21.387C24.3167 21.6457 25.3667 22.0333 26.4 22.55C26.8833 22.8 27.2707 23.1623 27.562 23.637C27.854 24.1123 28 24.6333 28 25.2V26C28 26.55 27.8043 27.021 27.413 27.413C27.021 27.8043 26.55 28 26 28H14Z",
    fill: "#5E6974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarFallback);
export default __webpack_public_path__ + "static/media/avatar-fallback.facc7ead65549099a892c27ae9c29171.svg";
export { ForwardRef as ReactComponent };